export default {
  activeAudios(store = {}) {
    if (store.video.audios) {
      const readyAudios = store.video.audios.filter(
        (item) => item.status === 'CONVERTED' || !item.status
      )
      if (readyAudios.length) return readyAudios
    }
    return []
  },
}
